import PublishingForm from './PublishingForm'

export default PublishingForm;